import { Roles, UserStatusType } from "../users/users";

export interface UserHeaderParams {
  portal: string;
  user: string;
}

export interface GetUserParams {
  portalUrl: string;
  email: string;
}

export interface CreateUserBody {
  portalUid?: string;
  status?: UserStatusType;
  thumbnail?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  roles?: Roles[];
  cognitoUser?: string;
  adminUser?: string;
  portalUrl?: string;
}

export interface User {
  UserUid: string;
  cognitoUser: string;
  UserPortalUid: string;
  PortalUid: string;
  status: UserStatusType | InfoStatusType;
  thumbnail?: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: Roles[] | Roles;
  dueDate?: string;
}

export enum InfoStatusType {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}
